<template>
  <div>
    <div id="captcha-button"></div>
    <div id="captcha-element"></div>
    <!--   <button id="refresh-button" @click="initCaptcha">重新初始化验证码</button> -->
  </div>
</template>

<script>
export default {
  name: 'CaptchaA',
  props: {},
  data() {
    return {
      captcha: null,
      captchaButton: null,
      region: 'cn',
      captchaVerifyParam: '' //验证码验签
    }
  },
  mounted() {
    this.$toast.loading('加载中...')
    this.captchaButton = document.getElementById('captcha-button')
    this.getIp()
  },
  methods: {
    getInstance(instance) {
      this.captcha = instance
      this.captchaButton.click()
      console.log('验证码所属区域是:', this.region)
      console.log('captcha', this.captcha)
      this.$toast.clear()
    },
    success(captchaVerifyParam) {
      // 入参为验签captchaVerifyParam
      // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
      // 2.根据校验结果来进行业务处理
      // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
      console.log('成功', captchaVerifyParam)
      this.captchaVerifyParam = captchaVerifyParam
      this.$betterwe.commonMethod(
        'onVerifyImageCaptchaSucceed',
        captchaVerifyParam
      )
    },
    // 验证码验证不通过回调函数
    fail(error) {
      console.error(error)
    },
    async getIp() {
      let res = await this.$http
        .getBaseApp('tool/IpTool/isMainlandChina')
        .catch(() => {})
      if (res) {
        res = res.data
        this.region = res.code == 200 ? 'cn' : 'sgp'
      } else {
        this.$toast('异常错误')
      }
      this.initCaptcha()
    },
    initCaptcha() {
      window.AliyunCaptchaConfig = {
        region: this.region,
        prefix: '140h2t'
      }
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src =
        'https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js'
      script.onload = () => {
        // 脚本加载完成后，初始化验证码（根据阿里云的文档进行初始化）
        window.initAliyunCaptcha({
          SceneId: '1dty9s7w', // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
          mode: 'popup', // 验证码模式。popup表示要集成的验证码模式为弹出式。无需修改
          element: '#captcha-element', // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
          button: '#captcha-button', // 触发验证码弹窗的元素。
          success: this.success,
          fail: this.fail,
          getInstance: this.getInstance, // 绑定验证码实例函数，无需修改
          onError: this.onError,
          onClose: this.onClose,
          slideStyle: {
            width: 360,
            height: 40
          }, // 滑块验证码样式，支持自定义宽度和高度，单位为px。其中，width最小值为320 px
          language: 'cn' // 验证码语言类型，支持简体中文（cn）、繁体中文（tw）、英文（en）
        })
      }
      document.head.appendChild(script)
    },
    onError() {
      this.$toast('验证码初始化失败')
    },
    onClose() {
      //如果已经成功则返回
      if (this.captchaVerifyParam) {
        return
      }
      this.$betterwe.onAppCloseRoute()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#aliyunCaptcha-mask {
  z-index: 999 !important;
}
#aliyunCaptcha-window-popup {
  z-index: 999 !important;
}
</style>
